module.exports = __webpack_public_path__ + "media/images/athletes/648-035b7ee659c18d0dc7b4e84ef82e1526.png";